import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	searchPlacholder: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.filters.search-placholder',
		defaultMessage: 'Search columns in CSV',
		description: 'Search bar placholder',
	},
	fieldsPrefix: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.filters.fields-prefix',
		defaultMessage: 'Fields: {filter}',
		description: 'Fields trigger prefix',
	},
	allFields: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.filters.all-fields',
		defaultMessage: 'All',
		description: 'All fields filter item',
	},
	mappedFields: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.filters.mapped-fields',
		defaultMessage: 'Mapped',
		description: 'Mapped fields filter item',
	},
	unmappedFields: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.filters.unmapped-fields',
		defaultMessage: 'Unmapped',
		description: 'Unmapped field filter item',
	},
	filterFieldsAriaLabel: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.filters.filter-fields-aria-label',
		defaultMessage: 'Filter fields',
		description: 'Unmapped field filter item',
	},
	showOnlyFieldsWithErrors: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.filters.show-only-fields-with-errors',
		defaultMessage: 'Show only fields with errors',
		description: 'Show only fields with errors toggle label',
	},
});
